import classNames from 'classnames'

import ArrowDown from './../arrow-down.svg'
import { Header } from '@crossfit/ui'
import style from './style.module.scss'

export type AllowedVariants =
  | 'black'
  | 'black-condensed'
  | 'gray'
  | 'gray-condensed'
  | 'white'
  | 'white-condensed'
  | 'white-condensed-card'

export type BaseProps = {
  className?: string
  details: React.ReactNode
  summary: string
}

type Props = BaseProps & {
  active?: boolean
  index: number
  showBottomBorders: boolean
  toggleActive: (arg0: number) => void
  variant: AllowedVariants
}

function AccordionItem(props: Props) {
  const {
    active = false,
    className,
    details,
    index,
    showBottomBorders,
    summary,
    toggleActive,
    variant,
  } = props

  const variantStyles = variant.split('-').map((v) => style[v])
  const isArrowVariant = variant != 'white-condensed-card'

  return (
    <li
      className={classNames(
        variantStyles,
        className && className,
        showBottomBorders && style.borders,
        active && style.active,
      )}
    >
      <button
        aria-expanded={active}
        className={style.summaryBlock}
        data-testid='accordion-item'
        onClick={() => toggleActive(index)}
      >
        <Header as='h3' size='xsmall' className={style.summaryText}>
          {summary}
        </Header>
        {isArrowVariant && <ArrowDown className={style.arrowIcon} />}
      </button>
      <div className={style.details}>{details}</div>
    </li>
  )
}

export default AccordionItem
